/**
 * TanStack Router: /workforce/roles/$roleId
 *
 * Role detail view
 * Layout: Authenticated (_auth)
 *
 * @see src/app/workforce/roles/[id]/page.tsx
 */
import { createFileRoute } from '@tanstack/react-router'
import RoleDetailPage from '@/app/workforce/roles/[id]/page'

/**
 * Route: /workforce/roles/$roleId
 * Layout: _auth (authenticated)
 * Component: RoleDetailPage
 */
export const Route = createFileRoute('/_auth/workforce/roles/$roleId/')({
  component: RoleDetailPage,
})
